<div class="flex flex-col w-full h-full">
  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'services.resources.aliasFrom' | transloco }} {{ resource.userName }} - {{ data.area.name | localize }}</div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto gap-4 p-6 sm:p-8 bg-gray-100 dark:bg-slate-900" fuseScrollbar>
    @for (formGroup of formArray.controls; track formGroup; let i = $index; let isFirst = $first; let isLast = $last) {
      <fuse-card [formGroup]="formGroup" class="flex flex-col p-4 bg-card overflow-visible">
        <div class="text-lg font-semibold text-primary mb-2">{{ (isFirst ? 'services.resources.currentAlias' : 'services.resources.futureAlias') | transloco }}</div>
        <div class="flex items-center justify-between">
          <mat-form-field class="w-1/2">
            <mat-label>{{ 'services.resources.alias' | transloco }}</mat-label>
            <input matInput type="text" formControlName="userAlias" class="uppercase" required />
            @if (formGroup.get('userAlias').invalid && formGroup.get('userAlias').errors && formGroup.get('userAlias').errors['required']) {
              <mat-error>
                {{ 'errorRequiredField' | transloco }}
              </mat-error>
            }
          </mat-form-field>
          @if (!isFirst) {
            <button mat-raised-button color="warn" (click)="deleteAlias(i)">
              <mat-icon class="text-on-warn" [svgIcon]="'mat_outline:delete'"></mat-icon>
              <span class="ml-2">{{ 'services.resources.deleteAlias' | transloco }}</span>
            </button>
          }
        </div>
        <div class="flex items-center justify-between">
          <div class="flex gap-2 w-1/2">
            <mat-form-field class="w-full">
              <mat-label>{{ 'from' | transloco }}</mat-label>
              <input matInput formControlName="from" [min]="isFirst ? undefined : nextDate(formArray.controls[i - 1].get('to').value) ?? nextDate(formArray.controls[i - 1].get('from').value)" [max]="formGroup.get('to').value ? previousDate(formGroup.get('to').value) : undefined"
                [matDatepicker]="datepickerFrom" (click)="openDatepickerOnClick(datepickerFrom)" readonly required />
                <mat-datepicker-toggle [disabled]="isFirst" matSuffix [for]="datepickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #datepickerFrom></mat-datepicker>
                @if (formGroup.get('from').invalid && formGroup.get('from').errors && formGroup.get('from').errors['required']) {
                  <mat-error>
                    {{ 'errorRequiredField' | transloco }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>{{ 'to' | transloco }}</mat-label>
                <input matInput formControlName="to" [min]="formGroup.get('from').value ? formGroup.get('from').value : undefined" [max]="isLast ? undefined : previousDate(formArray.controls[i + 1].get('from').value)"
                  [matDatepicker]="datepickerTo" (click)="openDatepickerOnClick(datepickerTo)" readonly />
                  <mat-datepicker-toggle matSuffix [for]="datepickerTo"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerTo></mat-datepicker>
                </mat-form-field>
              </div>
              @if (isLast) {
                <button mat-raised-button color="primary" (click)="addAlias()">
                  <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:add'"></mat-icon>
                  <span class="ml-2">{{ 'services.resources.newFutureAlias' | transloco }}</span>
                </button>
              }
            </div>
          </fuse-card>
        }
      </div>

      <!-- Actions -->
      <div class="flex flex-col sm:flex-row justify-end gap-2 p-4 w-full bg-gray-100 dark:bg-slate-900">
        <button (click)="closeDialog()" mat-stroked-button>
          {{ 'cancel' | transloco }}
        </button>
        <button (click)="save()" mat-flat-button color="primary">
          {{ 'save' | transloco }}
        </button>
      </div>
    </div>